import {
  PDFEDITOR_ON_CHECK_TOTAL_SECTIONS_HEIGHT,
  PDFEDITOR_ON_NAME_CHANGE,
  PDFEDITOR_ON_TYPE_CHANGE,
  PDFEDITOR_ON_CATEGORY_CHANGE,

  PDFEDITOR_ON_ADD_PAGE,
  PDFEDITOR_ON_ADD_SECTION,
  // PDFEDITOR_ON_ADD_COLUMN,

  PDFEDITOR_ON_DELETE_PAGE,
  PDFEDITOR_ON_DELETE_SECTION,
  // PDFEDITOR_ON_DELETE_COLUMN,

  PDFEDITOR_ON_SELECT_PAGE,
  PDFEDITOR_ON_SELECT_SECTION,
  PDFEDITOR_ON_SELECT_COLUMN,
  PDFEDITOR_ON_SELECT_TABLE_CELL,
  PDFEDITOR_ON_UPDATE_TABLE_ROW_PADDING,
  PDFEDITOR_ON_SELECT_PRODUCT_HEADER,

  PDFEDITOR_ON_UPDATE_PAGE,
  PDFEDITOR_ON_UPDATE_SECTION,
  PDFEDITOR_ON_UPDATE_COLUMN,
  PDFEDITOR_ON_UPDATE_TABLE_CELL,
  PDFEDITOR_ON_UPDATE_TABLE_CELL_WIDTH,
  PDFEDITOR_ON_UPDATE_PRODUCT_HEADER,

  PDFEDITOR_ON_GET_TEMPLATES,
  PDFEDITOR_ON_LOAD_TEMPLATE,

  PDFEDITOR_ON_MOVE_SECTION,
  PDFEDITOR_ON_MOVE_SECTION_FROM_PAGE,
  PDFEDITOR_ON_GEN_TEMPID,
  PDFEDITOR_ON_SET_NEW_TEMP,
  PDFEDITOR_ON_LOAD_IMAGE_GALLERY,
  PDFEDITOR_ON_MENU_TAB_CHANGE,

  PDFEDITOR_ON_ADD_TEMPLATE,
  PDFEDITOR_ON_RESPOSE,
  PDFEDITOR_ON_RESPOSE_RESET,
  PDFEDITOR_ON_MOVE_PAGE,
  PDFEDITOR_ON_RESPOSE_RESET_EMPTY
}  from '../constants/ActionTypes'
import { v4 as uuidv4 } from 'uuid';
import {isEmpty} from 'lodash'

const template = {
  _id: 1,
  Tempid: 'newTemp',
  afId: null,
  authId: null,
  created: '2020-10-15',
  lastChange: '2020-10-15',

  pages: [
    {
      id: uuidv4(),
      color: '#fff',
      bgImg: "",
      sections: [],
      selected: true
    }
  ]
}

const INIT_STATE = {
  templates: [],
  
  currentId: template.Tempid,

  currentTemplate: [],

  selectedPage: {},
  selectedSection: {},
  selectedColumn: {},
  selectedTableCell: {
    rowId: 0,
    vPadding: 0,
    cell: {
      id: 1,
      text: null
    }
  },
  selectedProductHeader: {
    id: null
  },

  totalSectionsHeight: 0,
  menuTab: 1,

  imageGallery: [],
  response: {},
}



export default (state = INIT_STATE, action) => {
  switch (action.type) {
    
    case PDFEDITOR_ON_CHECK_TOTAL_SECTIONS_HEIGHT: {
      let newPages = []
      state.currentTemplate.map(p => {
        let totalHeight = 0
        const sections = Array.from(document.querySelectorAll(".p"+p.id+"_section_id"))
        sections.map(s => {
          let height = Number(window.getComputedStyle(s,null).getPropertyValue("height").replace("px", ""))
          totalHeight += Math.round(height)
        })
        newPages.push({...p, totalSectionsHeight: totalHeight})
      })

      return {...state, currentTemplate: newPages}
    }
    case PDFEDITOR_ON_NAME_CHANGE: {
      return {...state, currentTemplateName: action.payload}
    }
    case PDFEDITOR_ON_TYPE_CHANGE: {
      return {...state, currentTemplateType: action.payload}
    }
    case PDFEDITOR_ON_CATEGORY_CHANGE: {
      return {...state, currentTemplateCategory: action.payload}
    }

    case PDFEDITOR_ON_ADD_PAGE: {
      const page = action.payload.page
      const dflag = action.payload.dflag
      const newPages = []
      // const newPage = {
      //   id: uuidv4(),
      //   sections: page === undefined ? [] : page.sections,
      //   color: page === undefined ? "#ffffff" : page.color,
      //   bgImg: page === undefined ? "" : page.bgImg,
      //   pageNumColor: page === undefined ? undefined : page.pageNumColor,
      //   pageNumBg: page === undefined ? undefined : page.pageNumBg,
      //   selected: false
      // }
      if(!isEmpty(state.currentTemplate)){
        state.currentTemplate.map(p => {
          newPages.push(p)
          if(p.id === page.id) {
            newPages.push({
              id: uuidv4(),
              sections: !dflag? [] : page.sections,
              color: !dflag ? "#ffffff" : page.color,
              bgImg: !dflag ? "" : page.bgImg,
              pageNumColor: !dflag? undefined : page.pageNumColor,
              pageNumBg: !dflag? undefined : page.pageNumBg,
              fontFamily: !dflag? undefined : page.fontFamily,
              selected: false
            })
          } 
        })
      } else {
        newPages.push({
          id: uuidv4(),
          sections: [],
          color: "#ffffff",
          bgImg: "",
          pageNumColor: undefined,
          pageNumBg: undefined,
          fontFamily: 'Titillium Web, sans-serif',
          selected: false
        })
      }
      

      console.log("PDFEDITOR_ON_ADD_PAGE", action)
      return {...state, 
        currentTemplate: newPages
      }
    }

    case PDFEDITOR_ON_ADD_SECTION: {
      let tsh = 0
      const newPages = []
      const page = action.payload.page
      const section = action.payload.section

      let newSelectedPage = {}

      const newSection = {
        id: uuidv4(),
        height: section === undefined ? 60 : section.height, 
        text: section === undefined ? '': section.text, 
        col: section === undefined ? [{ 
          id: 1, 
          type: 'none', 
          xPadding: 0, 
          yPadding: 0,
          tableData: {
            // hasHeader: true,
            // transparent: false,
            // headerFontSize: 18,
            // cellFontSize: 16,
            // cellTitleFontSize: 9,
            // header: {
            //   rowId: 0,
            //   vPadding: 3,
            //   cells: [
            //     {id: 1, text: 'newHeader', titel: 'Titel', input: false,checkbox: false, autoFill: '', align: 'left', width: 50},
            //     {id: 2, text: 'newHeader', titel: 'Titel', input: false,checkbox: false, autoFill: '', align: 'left', width: 50},
            //   ]
            // },
            // rows: [
            //   {
            //     rowId: 1,
            //     vPadding: 3,
            //     cells: [
            //       {id: 1, text: 'newCell', titel: 'Titel', input: false,checkbox: false, autoFill: '', align: 'left', width: 50},
            //       {id: 2, text: 'newCell', titel: 'Titel', input: false,checkbox: false, autoFill: '', align: 'left', width: 50},
            //     ]
            //   }
            // ]
          }
          ,
          productData: {
            // heading: '',
            // ongoing: false,
            // freeTextRow: false,
            // header: {
            //   rowId: 0,
            //   cells: [
            //     {id: 1, type: 'art', title: 'Product', align:'left', width: 25},
            //     {id: 2, type: 'price', title: 'Pris', align:'left', width: 25},
            //     {id: 3, type: 'qnt', title: <IntlMessages id="Table.Quantity"/>, align:'left', width: 25},
            //     {id: 4, type: 'total', title: 'Totalpris', align:'left', width: 25}
            //   ]
            // },
            // products: []
          },
          img: "",
          imgWidth: 100,
          imgAlignment: 'justify-content-start',
          text: "", 
          selected: false,
          width: 100,
          editable: false,
        }]: section.col.map(c=> {
          return {...c, selected: false}
        }),
        breakerTop: section === undefined ? false : section.breakerTop,
        breakerBottom: section === undefined ? false : section.breakerBottom,
        bgColor: section === undefined ? '#FFFFFF00': section.bgColor,
        selected: false
      }

      state.currentTemplate.map(p => {
        if(p.selected) {
          newPages.push({
            ...p,
            sections: [...p.sections, newSection]
          })
          newSelectedPage = {...p, sections: [...p.sections, newSection]}
          newSelectedPage.sections.map(s => {
            tsh += s.height
          })
        } else {
          newPages.push(p)
        }
      })

      console.log("PDFEDITOR_ON_ADD_SECTION", action)

      return {...state, selectedPage: newSelectedPage, currentTemplate: newPages}
    }

    // case PDFEDITOR_ON_ADD_COLUMN: {
    //   console.log("PDFEDITOR_ON_ADD_COLUMN", action)
    //   return state
    // }

    case PDFEDITOR_ON_DELETE_PAGE: {
      const newPages = []
      const page = action.payload
      state.currentTemplate.map(p => {
        if(p !== page)
          newPages.push(p)
      })
      console.log("PDFEDITOR_ON_DELETE_PAGE", action)
      return {...state, selectedPage: {}, selectedSection: {}, selectedColumn: {}, currentTemplate: newPages}
    }
    case PDFEDITOR_ON_MOVE_PAGE: {

      console.log("PDFEDITOR_ON_MOVE_PAGE", action)
      // console.log(action.payload.page)
      // console.log(action.payload.direction)

      const page = action.payload.page 
      const direction = action.payload.direction
      const from = action.payload.index
      const to = direction ? from - 1 : from + 1

      state.currentTemplate.splice(from, 1)
      state.currentTemplate.splice(to, 0, page)

      return {...state, selectedPage: {}, selectedSection: {}, selectedColumn: {}}
      
    }

    case PDFEDITOR_ON_DELETE_SECTION: {
      let tsh = 0
      const newPages = []
      const newSections = []
      const section = action.payload
      const selectedPage = state.selectedPage

      let newSelectedPage = {}

      state.currentTemplate.map(p => {
        if(p.id === selectedPage.id){
          p.sections.map(s => {
            if(s.id !== section.id)
              newSections.push(s)
          })
          newPages.push({
            ...p,
            sections: newSections
          })
          newSelectedPage = {...p, sections: newSections }
          newSelectedPage.sections.map(s => {
            tsh += s.height
          })
        } else {
          newPages.push(p)
        }
      })

      console.log("PDFEDITOR_ON_DELETE_SECTION", action)
      return {...state, selectedPage: newSelectedPage, selectedSection: {}, selectedColumn: {}, currentTemplate: newPages}
    }

    // case PDFEDITOR_ON_DELETE_COLUMN: {
    //   console.log("PDFEDITOR_ON_DELETE_COLUMN", action)
    //   return state
    // }

    case PDFEDITOR_ON_SELECT_PAGE: {
      const page = action.payload
      let newSelectedPage = {}
      if(!page.selected) {
        const newPages = []
        state.currentTemplate.map(p => {
          if(page.id === p.id) {
            newPages.push({
              ...p,
              selected: true
            })
            newSelectedPage = {...p, selected: true}
          } else{
            newPages.push({
              ...p,
              selected: false,
              sections: p.sections.map(s => {
                return {
                  ...s,
                  selected: false,
                  col: s.col.map(c => {
                    return {
                      ...c,
                      selected: false
                    }
                  })
                }
              })
            })
          }
        })
        console.log("PDFEDITOR_ON_SELECT_PAGE", action)
        return {...state, selectedPage: newSelectedPage, selectedSection: {}, selectedColumn: {}, currentTemplate: newPages}
      } else
        return state
    }

    case PDFEDITOR_ON_SELECT_SECTION: {
      const section = action.payload
      const selectedPage = state.selectedPage

      if(!section.selected && selectedPage !== null) {
        const newPages = []
        let newSelectedSection = {}
  
        state.currentTemplate.map(p => {
          if(p.id === selectedPage.id){
            let newSections = []
            let deSelectedColumns = []
  
            p.sections.map(s => {
              s.col.map(c => {
                deSelectedColumns.push({
                  ...c,
                  selected: false
                })
              })
  
              //Select right Section
              if(s.id === section.id) {
                newSections.push({
                  ...s,
                  col: deSelectedColumns,
                  selected: true
                })
                newSelectedSection = {...s, col: deSelectedColumns, selected: true }
              } else {
                newSections.push({
                  ...s,
                  col: deSelectedColumns,
                  selected: false
                })
              }
              deSelectedColumns = []
            })
  
            newPages.push({...p, sections: newSections})
          } 
          
          else {
            newPages.push(p)
          }
        })
        console.log("PDFEDITOR_ON_SELECT_SECTION", action)
        return {...state, selectedSection: newSelectedSection, selectedColumn: {}, currentTemplate: newPages}
      } else
        return state

    }

    case PDFEDITOR_ON_SELECT_COLUMN: {
      let column = action.payload.column
      let section = action.payload.section
      let selectedPage = state.selectedPage
      let newSelectedPage = {}
      let newSelectedSection = {}
      let newSelectedColumn = {}
      if(!column.selected){
        let newPages = []
        
        //Select section
        state.currentTemplate.map(p => {
          let newSections = []
          if(selectedPage.id === p.id){
            p.sections.map(s => {
              if(s.id === section.id){
                newSections.push({...s, selected: true})
              } else {
                newSections.push({...s, selected: false})
              }
            })
            newPages.push({
              ...p,
              sections: newSections
            })
          } else {
            newPages.push(p)
          }
        })
        let finalPages = []
        //Select column
        newPages.map(p => {
          let finalSections = []
          if(selectedPage.id === p.id) {
            p.sections.map(s => {
              let newColumns = []
              s.col.map(c => {
                if(c.id === column.id && s.selected){
                  newColumns.push({...c, selected: true})
                  newSelectedColumn = {...c, selected: true}
                }
                else {
                  newColumns.push({...c, selected: false})
                } 
              })
              if(s.selected)
                newSelectedSection = {...s, col: newColumns}
              finalSections.push({
                ...s,
                col: newColumns
              })
            })
            finalPages.push({
              ...p,
              sections: finalSections
            })
            newSelectedPage = {...p, sections: finalSections }
          } else {
            finalPages.push(p)
          }
        })
        console.log("PDFEDITOR_ON_SELECT_COLUMN", action)
        
        return {...state, currentTemplate: finalPages, selectedPage: newSelectedPage, selectedSection: newSelectedSection, selectedColumn: newSelectedColumn}
      } else 
        return state
    }

    case PDFEDITOR_ON_SELECT_TABLE_CELL: {
      return {...state, selectedTableCell: { rowId: action.payload.row.rowId, vPadding: action.payload.row.vPadding ,cell: action.payload.cell}}
    }
    case PDFEDITOR_ON_SELECT_PRODUCT_HEADER: {
      return {...state, selectedProductHeader: action.payload}
    }

    case PDFEDITOR_ON_UPDATE_PAGE: {
      const newPages = []
      const page = action.payload

      state.currentTemplate.map(p => {
        if(p.id === page.id) {
          newPages.push({...page, selected: true})
        } else {
          newPages.push(p)
        }
      })

      console.log("PDFEDITOR_ON_UPDATE_PAGE", action)
      return {...state, selectedPage: page, currentTemplate: newPages}
    }

    case PDFEDITOR_ON_UPDATE_SECTION: {
      const newPages = [] 
      const section = action.payload
      const selectedPage = state.selectedPage

      let newSelectedPage = {}

      state.currentTemplate.map(p => {
        let newSections = []

        if(p.id === selectedPage.id){
          
          p.sections.map(s => {
            if(s.id === section.id) {
              newSections.push(section)
            } else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
          newSelectedPage = {...p, sections: newSections}
        } else {
          newPages.push(p)
        }
      })

      console.log("PDFEDITOR_ON_UPDATE_SECTION", action)
      return {...state, selectedPage: newSelectedPage, selectedSection: section, currentTemplate: newPages}
    }

    case PDFEDITOR_ON_UPDATE_COLUMN: {
      const newPages = [] 
      const selectedPage = state.selectedPage
      const selectedSection = state.selectedSection
      const selectedColumn = state.selectedColumn
      const column = action.payload

      let newSelectedSection = {}
      let newSelectedPage = {}
      let newSelectedColumn = {}
      
      state.currentTemplate.map(p => {
        let newSections = []

        if(p.id === selectedPage.id){
          p.sections.map(s => {
            
            if(s.id === selectedSection.id){
              let newColumns = []
              s.col.map(c => {
                if(c.id === selectedColumn.id && c.selected){
                  newColumns.push({...column, id: c.id})
                  newSelectedColumn = {...column, id: c.id}
                } else {
                  newColumns.push(c)
                }
              })
              newSections.push({...s, col: newColumns})
              newSelectedSection = {...s, col: newColumns}
            } else {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
          newSelectedPage = {...p, sections: newSections}
        } else {
          newPages.push(p)
        }
      })

      console.log("PDFEDITOR_ON_UPDATE_COLUMN", action)
      return {...state, selectedPage: newSelectedPage, selectedSection: newSelectedSection, selectedColumn: newSelectedColumn, currentTemplate: newPages}
    }


    case PDFEDITOR_ON_UPDATE_TABLE_CELL: {
      let rowId = action.payload.rowId
      let cell = action.payload.cell

      let newPages = []
      let newSelectedPage = {}
      let newSelectedSection = {}
      let newSelectedColumn = {}

      state.currentTemplate.map(p => {
        let newSections = []
        if(p.selected) {
          p.sections.map(s => {
            let newColumns = []
            if(s.selected){
              s.col.map(c => {
                if(c.selected) {
                  let newTableData = {}
                  let newCells = []

                  if(rowId === 0) {
                    c.tableData.header.cells.map(c => {
                      if(c.id === cell.id)
                        newCells.push(cell)
                      else
                        newCells.push(c)
                    })
                    newTableData = {
                      ...c.tableData,
                      header: {
                        rowId: 0,
                        cells: newCells
                      }
                    }
                  }
                  else {
                    let newRows = []
                    c.tableData.rows.map(r => {
                      if(r.rowId === rowId) {
                        let newCells = []
                        r.cells.map(c => {
                          if(c.id === cell.id) {
                            newCells.push(cell)
                          } else {
                            newCells.push(c)
                          }
                        })
                        newRows.push({...r, cells: newCells})
                      } else {
                        newRows.push(r)
                      }
                    })
                    newTableData = {
                      ...c.tableData,
                      rows: newRows
                    }
                  }
                  newSelectedColumn = {...c, tableData: newTableData}
                  newColumns.push({...c, tableData: newTableData})
                } else {
                  newColumns.push(c)
                }
              })
              newSelectedSection = {...s, col: newColumns}
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newSelectedPage = {...p, sections: newSections}
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })

      return {...state, currentTemplate: newPages, selectedTableCell: { rowId, cell }, selectedColumn: newSelectedColumn, selectedSection: newSelectedSection, selectedPage: newSelectedPage}
    }

    case PDFEDITOR_ON_UPDATE_TABLE_CELL_WIDTH: {
      let rowId = action.payload.rowId
      let width = action.payload.width
      let cell = action.payload.cell

      let newPages = []
      let newSelectedPage = {}
      let newSelectedSection = {}
      let newSelectedColumn = {}

      state.currentTemplate.map(p => {
        let newSections = []
        if(p.selected) {
          p.sections.map(s => {
            let newColumns = []
            if(s.selected){
              s.col.map(c => {
                if(c.selected) {
                  let newTableData = {}
                  let newRows = []
                  let newCells = []

                  c.tableData.header.cells.map(c => {
                    if(c.id === cell.id)
                      newCells.push({...c, width: width})
                    else
                      newCells.push(c)
                  })
                  newTableData = {
                    ...c.tableData,
                    header: {
                      rowId: 0,
                      cells: newCells
                    }
                  }

                  c.tableData.rows.map(r => {
                      newCells = []
                      r.cells.map(c => {
                        if(c.id === cell.id) {
                          newCells.push({...c, width: width})
                        } else {
                          newCells.push(c)
                        }
                      })
                      newRows.push({...r, cells: newCells})
                  })
                  newTableData = {
                    ...newTableData,
                    rows: newRows
                  }
                  newSelectedColumn = {...c, tableData: newTableData}
                  newColumns.push({...c, tableData: newTableData})
                } else {
                  newColumns.push(c)
                }
              })
              newSelectedSection = {...s, col: newColumns}
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newSelectedPage = {...p, sections: newSections}
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })

      return {...state, currentTemplate: newPages, selectedTableCell: { rowId, cell }, selectedColumn: newSelectedColumn, selectedSection: newSelectedSection, selectedPage: newSelectedPage}
    }
    case PDFEDITOR_ON_UPDATE_TABLE_ROW_PADDING: {
      let rowId = action.payload.rowId
      let cell = action.payload.cell
      let padding = action.payload.padding

      let newPages = []
      let newSelectedPage = {}
      let newSelectedSection = {}
      let newSelectedColumn = {}

      state.currentTemplate.map(p => {
        let newSections = []
        if(p.selected) {
          p.sections.map(s => {
            let newColumns = []
            if(s.selected){
              s.col.map(c => {
                if(c.selected) {
                  let newTableData = {}
                  let newRows = []

                  if(rowId === 0){
                    newTableData = {
                      ...c.tableData,
                      header: {
                        ...c.tableData.header,
                        rowId: 0,
                        vPadding: padding,
                      }
                    }
                  } else {
                    c.tableData.rows.map(r => {
                      if(r.rowId === rowId) 
                        newRows.push({...r, vPadding: padding})
                      else
                        newRows.push(r)
                    })
                    newTableData = {
                      ...c.tableData,
                      rows: newRows
                    }
                  }
                  newSelectedColumn = {...c, tableData: newTableData}
                  newColumns.push({...c, tableData: newTableData})
                } else {
                  newColumns.push(c)
                }
              })
              newSelectedSection = {...s, col: newColumns}
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newSelectedPage = {...p, sections: newSections}
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })

      return {...state, currentTemplate: newPages, selectedTableCell: { rowId, vPadding: padding, cell }, selectedColumn: newSelectedColumn, selectedSection: newSelectedSection, selectedPage: newSelectedPage}
    }

    case PDFEDITOR_ON_UPDATE_PRODUCT_HEADER: {
      let header = action.payload

      let newPages = []
      let newSelectedPage = {}
      let newSelectedSection = {}
      let newSelectedColumn = {}

      state.currentTemplate.map(p => {
        let newSections = []
        if(p.selected) {
          p.sections.map(s => {
            let newColumns = []
            if(s.selected){
              s.col.map(c => {
                if(c.selected) {
                  let newProductData = {}
                  let newCells = []

                  c.productData.header.cells.map(c => {
                    if(c.id === header.id)
                      newCells.push(header)
                    else
                      newCells.push(c)
                  })
                  newProductData = {
                    ...c.productData,
                    header: {
                      rowId: 0,
                      cells: newCells
                    }
                  }
                  

                  newSelectedColumn = {...c, productData: newProductData}
                  newColumns.push({...c, productData: newProductData})
                } else {
                  newColumns.push(c)
                }
              })
              newSelectedSection = {...s, col: newColumns}
              newSections.push({...s, col: newColumns})
            }
            else {
              newSections.push(s)
            }
          })
          newSelectedPage = {...p, sections: newSections}
          newPages.push({...p, sections: newSections})
        } else {
          newPages.push(p)
        }
      })

      return {...state, currentTemplate: newPages, selectedProductHeader: header, selectedColumn: newSelectedColumn, selectedSection: newSelectedSection, selectedPage: newSelectedPage}
    }


    case PDFEDITOR_ON_GET_TEMPLATES: {
      return {...state, templates: action.payload}
    }
    case PDFEDITOR_ON_LOAD_TEMPLATE: {

      let template = action.payload[0]
      
      console.log(JSON.parse(template.Pages))

      return {
        ...state, 
        currentId: template.Tempid,
        currentTemplateName: template.Name,
        currentTemplateType: template.Type,
        currentTemplateCategory: template.Category,

        currentTemplate: JSON.parse(template.Pages),
        
        selectedPage: {},
        selectedSection: {},
        selectedColumn: {}
      }
    }
    case PDFEDITOR_ON_MOVE_SECTION: {
      let hindex = action.payload.hindex
      let dindex = action.payload.dindex
      let initSections = action.payload.page.sections
      let page = action.payload.page
      let newPages = []
      let newSelectedPage = {}
      let _newSections = []
      

      initSections.map((s, index) => {
        if(index === hindex)
          _newSections.push(initSections[dindex])
        else if(index === dindex)
          _newSections.push(initSections[hindex])
        else
          _newSections.push(s)
      })

      state.currentTemplate.map(p => {
        if(p === page){
          newPages.push({...p, sections: _newSections})
          newSelectedPage = {...p, sections: _newSections}
        } else {
          newPages.push(p)
        }
      })

      console.log("PDFEDITOR_ON_MOVE_SECTION", action)


      return {...state, selectedPage: newSelectedPage, currentTemplate: newPages}
    }
    case PDFEDITOR_ON_MOVE_SECTION_FROM_PAGE: {
      console.log("PDFEDITOR_ON_MOVE_SECTION_FROM_PAGE", action)

      const newPages = []
      const targetPage = action.payload.tpage
      const fromPage = action.payload.fpage

      

      const section = action.payload.section

      state.currentTemplate.map(p => {
        const newSections = []
        if(p.id === fromPage.id) {
          p.sections.map(s => {
            if(s.id !== section.id) {
              newSections.push(s)
            }
          })
          newPages.push({...p, sections: newSections})
        } else if (p.id === targetPage.id) {
          newPages.push({...p, sections: [...p.sections, {...section, selected: false, col: section.col.map(c => {return {...c, selected: false}})}]})
        } else {
          newPages.push(p)
        }
      })


      return {...state, currentTemplate: newPages}
    }
    case PDFEDITOR_ON_GEN_TEMPID: {
      let newID = action.payload
      return {...state, currentId: newID}
    }
    case PDFEDITOR_ON_SET_NEW_TEMP: {
      const id = uuidv4()
      return {
        ...state, 
        currentId: 'newTemp', 
        currentTemplate: [
          {
            id: id,
            color: '#fff',
            bgImg: "",
            sections: [],
            selected: true,
            totalSectionsHeight: 0,
          }
        ],
        selectedPage: {
          id: id,
          color: '#fff',
          bgImg: "",
          sections: [],
          selected: true,
          totalSectionsHeight: 0,
        },
        selectedSection: {},
        selectedColumn: {}
      }
    }
    case PDFEDITOR_ON_LOAD_IMAGE_GALLERY: {
      // console.log(action.payload)
      return {...state, imageGallery: action.payload }
    }
    case PDFEDITOR_ON_ADD_TEMPLATE: {
      return {
        ...state, 
        selectedPage: {},
        selectedSection: {},
        selectedColumn: {}
      }
    }
    case PDFEDITOR_ON_MENU_TAB_CHANGE: {
      console.log("PDFEDITOR_ON_MENU_TAB_CHANGE", action)
      return {...state, menuTab: action.payload}
    }
    case PDFEDITOR_ON_RESPOSE: {
      return {...state, response: action.payload}
    }
    case PDFEDITOR_ON_RESPOSE_RESET: {
      return {...state, response: {...state.response, show: false}}
    }
    case PDFEDITOR_ON_RESPOSE_RESET_EMPTY: {
      return {...state, response: {}}
    }
    default:
      return state;  
  }
}